export default {
  schema: {
    type: 'object',
    properties: {
      record_ref: {
        type: 'string',
        title: 'Record From Other Screen'
      }
    },
    required: [],
    dependencies: {},
    additionalProperties: false,
    definitions: {},
    title: 'Component Ref at Screen Level Here'
  },
  uiSchema: {
    record_ref: {
      'ui:widget': 'select'
    }
  },
  formData: {}
};